var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"53d1008c3a4b149fd75c5f34e3d254a525f13ffb"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["kelp-dapp@staderlabs"]={id:"53d1008c3a4b149fd75c5f34e3d254a525f13ffb"};
      